import gql from 'graphql-tag';
export const StatFeatureStaffSignInOut = gql `
    fragment StatFeatureStaffSignInOut on EmployeeCheckInFeatureSettingsFlags {
        isEnabled
        canOptIn
    }
`;
